import { Flex, Box } from '@chakra-ui/react'
import { getRarityColorMap, rarityType } from '../constants/skinPropertes'
import { getSteamImageUrl } from '../utils/getSteamImage'
import CornerLinesSmall from './Icons/CornerLinesSmall'
import ImageLoad from './ImageLoad'

const PrizeBox = ({
  rarity,
  imageUrl,
  name,
  children,
  isMobile = false,
}: {
  rarity: rarityType
  imageUrl: string
  name: string
  children?: React.ReactNode
  isMobile?: boolean
}) => {
  const rarityColor = getRarityColorMap(rarity as unknown as rarityType)
  return (
    <Box sx={{ transformStyle: 'preserve-3d' }} height={'100%'} width={'100%'}>
      <Flex
        direction={'column'}
        position={'relative'}
        overflow={'hidden'}
        _before={{
          background: `${rarityColor.background}`,
          content: '""',
          height: '130%',
          left: 0,
          pointerEvents: 'none',
          position: 'absolute',
          top: '-30%',
          width: '100%',
          zIndex: '-1',
        }}
        pb={'10px'}
        borderBottom={`1px solid ${rarityColor.border}`}
        height={'100%'}
        width={'100%'}
      >
        <Box maxW={['65%', '80%']} minH={['70%', '90%']} margin={'0 auto'} position={'relative'}>
          <Box
            position={'absolute'}
            top={isMobile ? '70%' : '50%'}
            left={'50%'}
            transform={'translate(-50%, -50%)'}
          >
            <CornerLinesSmall color={getRarityColorMap(rarity as unknown as rarityType).border} />
          </Box>
          <ImageLoad
            imageSrc={imageUrl}
            defaultSrc={imageUrl}
            fallback={getSteamImageUrl(name)}
            aspectRatio={116 / 87}
            mt={1}
            mx={'auto'}
            width={'80%'}
            initIsLoaded={true}
          />
        </Box>

        {children}
      </Flex>
    </Box>
  )
}

export default PrizeBox
